import { resolveLockerStatus } from "./orderCreateEligibility";

export const LOCKER_INACTIVE_MODAL_MESSAGE =
  "Your Virtual Locker is currently inactive. To activate it, please create an order and add items, or contact an administrator.";

export const LOCKER_INACTIVE_MODAL_MESSAGE_WITH_ORDER =
  "Your Virtual Locker is currently inactive. Please contact an administrator if you need help activating it.";

export const LOCKER_INACTIVE_BANNER_TITLE = "Virtual Locker Inactive";

export const LOCKER_INACTIVE_BANNER_MESSAGE =
  "Your virtual locker is currently inactive. Create a new order to activate your locker.";

export const CREATE_ORDER_PATH = "/dashboard/orders?createOrder=true";

const STORAGE_PREFIX = "inactive-locker-modal-dismissed";

export function hasVirtualLocker(locker) {
  return locker && !Array.isArray(locker) && Boolean(locker.locker_id);
}

export function isVirtualLockerInactive(locker) {
  return hasVirtualLocker(locker) && resolveLockerStatus(locker) === "inactive";
}

function storageKey(lockerId) {
  return `${STORAGE_PREFIX}:${lockerId}`;
}

export function isInactiveLockerModalDismissed(lockerId) {
  if (!lockerId || typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(storageKey(lockerId)) === "1";
  } catch {
    return false;
  }
}

export function dismissInactiveLockerModal(lockerId) {
  if (!lockerId || typeof window === "undefined") return;
  try {
    window.localStorage.setItem(storageKey(lockerId), "1");
  } catch {
    /* ignore */
  }
}

export function clearInactiveLockerModalDismiss(lockerId) {
  if (!lockerId || typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(storageKey(lockerId));
  } catch {
    /* ignore */
  }
}
